import { Music, Play, VideoPlay } from "iconsax-react";
import { useTranslation } from "react-i18next";
import { CONTENT_SOURCE, CONTENT_TYPE } from "./constants";
import { embedUrlFor, thumbnailUrlFor, typeKey } from "./helpers";

export default function MediaPreview({ content, draft, filePreview }) {
    const { t } = useTranslation();
    const source = draft?.source || content?.source;
    const type = Number(draft?.contentType || content?.content_type);
    const embed = embedUrlFor(content, draft);
    const thumb = thumbnailUrlFor(content, draft);
    const localUrl = filePreview;

    if (localUrl && type === CONTENT_TYPE.AUDIO) {
        return (
            <div className="studio-preview studio-preview-audio">
                <Music size={28} aria-hidden="true" />
                <audio controls src={localUrl} preload="metadata">
                    {t("contentStudio.preview.audioFallback")}
                </audio>
            </div>
        );
    }
    if (localUrl && type === CONTENT_TYPE.VIDEO) {
        return (
            <video
                className="studio-preview-media"
                controls
                src={localUrl}
                preload="metadata"
            />
        );
    }
    if (localUrl && type === CONTENT_TYPE.IMAGE) {
        return (
            <img
                className="studio-preview-media"
                src={localUrl}
                alt={draft?.name || content?.name || t("contentStudio.preview.image")}
            />
        );
    }
    if (
        (source === CONTENT_SOURCE.YOUTUBE || source === CONTENT_SOURCE.APARAT) &&
        embed
    ) {
        return (
            <iframe
                className="studio-preview-frame"
                src={embed}
                title={draft?.name || content?.name || t("contentStudio.preview.embed")}
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
            />
        );
    }
    if (source === CONTENT_SOURCE.LINK && embed) {
        return (
            <a
                className="studio-preview-link"
                href={embed}
                target="_blank"
                rel="noreferrer"
            >
                <Play size={20} aria-hidden="true" />
                {embed}
            </a>
        );
    }
    if (content?.file && type === CONTENT_TYPE.AUDIO) {
        return (
            <div className="studio-preview studio-preview-audio">
                <Music size={28} aria-hidden="true" />
                <audio controls src={content.file} preload="metadata">
                    {t("contentStudio.preview.audioFallback")}
                </audio>
            </div>
        );
    }
    if (content?.file && type === CONTENT_TYPE.VIDEO) {
        return (
            <video
                className="studio-preview-media"
                controls
                src={content.file}
                preload="metadata"
                playsInline
            />
        );
    }
    if (content?.file && type === CONTENT_TYPE.IMAGE) {
        return (
            <img
                className="studio-preview-media"
                src={content.file}
                alt={content?.name || t("contentStudio.preview.image")}
            />
        );
    }
    if (thumb) {
        return (
            <img
                className="studio-preview-media"
                src={thumb}
                alt={content?.name || t("contentStudio.preview.image")}
            />
        );
    }
    return (
        <div className="studio-preview studio-preview-empty">
            <VideoPlay size={28} aria-hidden="true" />
            <span>
                {t(`contentStudio.type.${typeKey(type)}`)} —{" "}
                {t("contentStudio.preview.empty")}
            </span>
        </div>
    );
}
